import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import type { InstitutionAmlCtfSanctionsOrDefaults } from '@/features/institution/aml-ctf-sanctions/schema';
import { InstitutionFieldDocument } from '@/features/institution/components/fields/document';
import { DocumentSource } from '@/services/api/documents';

const InstitutionAmlCtfSanctionsFieldsetPolicies = () => {
  const form = useFormContext<InstitutionAmlCtfSanctionsOrDefaults>();
  const { t } = useTranslation();
  const [amlCtfPolicies, sanctionsPolicies] = form.watch(['amlCtfPolicies', 'sanctionsPolicies']);

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="amlCtfPolicies"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.policies.amlCtfPolicies')}*</FormLabel>
            <FormControl>
              <RadioGroup defaultValue={field.value} variant="cards" aria-label={t('institutionDetails.amlCtfSanctions.policies.amlCtfPolicies')} onValueChange={field.onChange}>
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      {amlCtfPolicies === 'YES' ? (
        <InstitutionFieldDocument<InstitutionAmlCtfSanctionsOrDefaults>
          label={t('institutionDetails.amlCtfSanctions.policies.amlCtfPolicyDocument')}
          name="amlCtfPolicyDocument"
          source={DocumentSource.LICENCES_AND_POLICIES}
        />
      ) : null}
      <FormField
        control={form.control}
        name="sanctionsPolicies"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.amlCtfSanctions.policies.sanctionsPolicies')}*</FormLabel>
            <FormControl>
              <RadioGroup defaultValue={field.value} variant="cards" aria-label={t('institutionDetails.amlCtfSanctions.policies.sanctionsPolicies')} onValueChange={field.onChange}>
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      {sanctionsPolicies === 'YES' ? (
        <InstitutionFieldDocument<InstitutionAmlCtfSanctionsOrDefaults>
          label={t('institutionDetails.amlCtfSanctions.policies.sanctionsPolicyDocument')}
          name="sanctionsPolicyDocument"
          source={DocumentSource.LICENCES_AND_POLICIES}
        />
      ) : null}
    </div>
  );
};
InstitutionAmlCtfSanctionsFieldsetPolicies.displayName = 'InstitutionAmlCtfSanctionsFieldsetPolicies';

export { InstitutionAmlCtfSanctionsFieldsetPolicies };
